// main.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { GlobalService } from "../serivces/global.service";
import { ToastrService } from "../serivces/toastr.service";
import { environment } from "../../environments/environment";
import { catchError, throwError } from "rxjs";

export const MainInterceptor: HttpInterceptorFn = (request, next) => {
  const globalService = inject(GlobalService);
  const toastrService = inject(ToastrService);

  const token = sessionStorage.getItem("Token");
  const API_URL = environment.API_URL;

  if (token && request.url.includes(API_URL)) {
    request = request.clone({
      headers: request.headers.set("Authorization", "Bearer " + token),
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const message = error.error?.message || error.error?.Message || error.message || "An error occurred";

      switch (error.status) {
        case 401:
          toastrService.error("Unauthorized");
          break;
        case 404:
          toastrService.warning(message);
          break;
        default:
          toastrService.error(message);
      }

      return throwError(() => error);
    })
  );
};
